import * as React from 'react';
import { useParams } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';

type CourseParams = {
  id: string;
};

const CourseScreen: React.FunctionComponent = () => {
  let { id } = useParams<CourseParams>();

  return (
    <MainLayout>
      <h1>{id}</h1>
    </MainLayout>
  );
};

export default CourseScreen;
